import { configureStore } from '@reduxjs/toolkit';
import { reducers } from './reducers.ts';
import { accountsRootApi, agentRootApi, servicesRootApi, usersRootApi } from './api.ts';
import type { TypedUseSelectorHook } from 'react-redux';
import { useDispatch, useSelector } from 'react-redux';

const store = configureStore({
  reducer: reducers,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware()
      .concat(servicesRootApi.middleware)
      .concat(usersRootApi.middleware)
      .concat(accountsRootApi.middleware)
      .concat(agentRootApi.middleware),
  preloadedState: {},
});

export type AppState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppSelector: TypedUseSelectorHook<AppState> = useSelector;
export const useAppDispatch: () => AppDispatch = useDispatch;

export default store;
